import React, { Component } from 'react';
import Loader from '../../container/Loader';
import { Form } from 'reactstrap';
import Swal from 'sweetalert2'
import api from "../../services/api";
import mail from "../../services/mail";
import { getId, getToken } from "../../services/auth";
import Email from "../Email";
import { renderEmail } from 'react-html-email'

class FormUserEmail extends Component {
  state = {
    loading: false,
    errors: [],
    email: '',
    password: '123456'
  }

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this);
    this.submitFormAdd = this.submitFormAdd.bind(this);
  }

  handleChange(e){
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  Email(email, password) {

    let conteudo = '';
    let subject = '';

    subject = 'Bem vindo ao Dommus - Cadastro do Usuário';
    conteudo = renderEmail(<Email email={email} password={password}/>);

    mail.post('vendaonline/dommus-mail',
    {
      email: email,
      subject: subject,
      conteudo: conteudo
      
    })
    .then((response) => {
      console.log(response)
    }).catch((error) => {
      console.log(error)
    });    
  }

  submitFormAdd(e) {
    e.preventDefault();
    if(this.validate()){
      const token = getToken();
    api.post('usuario', 
    {
      email: this.state.email, 
      nome: this.state.email,
      password: this.state.password,
      id_tipo: 1, // ?
      id_logado: getId() 
    },
    { headers: { token }} )
    .then((response) => {
      this.Email(this.state.email, this.state.password);
      Swal.fire({
        title: response['status'] ? 'Usuário cadastrado com sucesso' : 'Ocorreu um erro ao salvar, tente novamente.',
        icon: response['status'] ? 'success': 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.value) {
          window.location.reload();
        }
    })
    }).catch((error) => {
      Swal.fire({
      title: 'E-mail já cadastrado.',
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      })
    });    
    }  
  }

  validate(){
    let email = this.state.email;
    let errors = {};
    let isValid = true;
    
    if (!email) {
      isValid = false;
      errors["email"] = "Por favor, indique o seu endereço de e-mail.";
    }

    if (typeof email !== "undefined") {
        
      var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(email)) {
        isValid = false;
        errors["email"] = "Por favor insira o endereço de e-mail válido.";
      }
    }

    this.setState({
      errors: errors
    });

    return isValid;
}

  render() {
    const isLoggedIn = this.state.loading;
    return (
      <Form style={{ marginBottom: isLoggedIn ? '100px' : ''}} onSubmit={this.submitFormAdd}>
        {isLoggedIn ? <Loader /> : <>
        <div className="tab-pane fade pt-3 active show" id="cadastro" role="tabpanel" aria-labelledby="cadastro">
          <div className="cadastro-usuario-wrapper">
            <header >
              Identificação do usuário
            </header>
            <div className="cadastro-wrapper is-overflow" >
              <div className="dados-wrapper" >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="email" className="labelB">E-mail de convite ao usuário <span style={{color: 'red'}}>*</span></label>
                      <input type="email" name="email" defaultValue={this.state.email === null ? '' : this.state.email}
                        className="form-control error"
                        placeholder="E-mail"
                        onChange={this.handleChange.bind(this)}
                      />
                      <small className="form-text text-danger">{this.state.errors.email}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{borderTop: '1px solid #dee2e6', marginTop: '15px'}}>
          <button type="submit" className="btn btn-primary" style={{marginRight:'-15px'}}>
            <i className="fas fa-paper-plane" aria-hidden="true" style={{marginRight: '15px'}}></i> ENVIAR CONVITE
          </button>
        </div>
        </>}
      </Form>
    );
  }
}

export default FormUserEmail